module.exports = __webpack_public_path__ + "media/images/site/wpp-c2b917e6a1b806b791f6bc886c9e3edd.png";